export default "https://client.chat.ao.com/1289/beta/without-externals/assets/images/fatal-error-bg@2x.png?315c2d27c251bc41b569b488db0b5ceb";